import React from "react";

interface FooterProps {
  onNext: (showWeb: boolean) => void;
  onBack?: () => void;
  showBackButton?: boolean;
  showNextButton?: boolean;
  showWeb?: boolean
  showActive?: boolean
}

const Footer: React.FC<FooterProps> = ({ onNext, onBack, showBackButton, showNextButton, showWeb = false, showActive }) => {
  return (
    <><div className=" bg-white shadow-lg z-10 bg-white w-[95%] md:w-[800px] h-[50px] sm:h-[60px] rounded-[20px] sm:rounded-[25px] shadow-md mt-4 md:mt-4 sm:mt-6 mb-6 flex items-center  sm:px-4">
      <div className={`w-1/2 h-full flex items-center justify-center ${showBackButton ? "" : "invisible"}`}>
        {showBackButton && (
          <button
            onClick={onBack}
            className="w-full h-full flex items-center justify-center text-sm sm:text-base lg:text-lg font-bold"
          >
            <span className="text-black">Zurück</span>
          </button>
        )}
      </div>

      <div className="w-[3px] h-[70%] bg-red-600 mx-2"></div>

      <div className="w-1/2 h-full flex items-center justify-center p-2">
        {showNextButton && <button
          onClick={() => { onNext(showWeb) }}
          disabled={showActive}
          className={`w-full h-full flex items-center justify-center text-sm sm:text-base lg:text-lg font-bold ${!showActive ? "text-black" : "text-gray-100 colour-gray-100 opacity-50 cursor-not-allowed"
            }`}        >
          <span className="text-black">{showWeb ? "Vielen Dank für Ihre Anfrage" : "Weiter"}</span>
          {!showActive && <span className="text-red-600 ml-2">&gt;</span>}

        </button>}
      </div>

    </div>

      <div className="mt-2 flex gap-6 text-sm sm:text-base">

        <a
          href="https://kd-ueberdachung.de/impressum/"
          target="_blank"
          className="text-white hover:underline font-bold text-center text-lg sm:text-lg md:text-lg">
          Impressum
        </a>
        <a
          href="https://kd-ueberdachung.de/datenschutz/"
          target="_blank"
          className="text-white hover:underline font-bold text-center text-lg sm:text-lg md:text-lg ">
          Datenschutz
        </a>
      </div>
    </>
  );
};

export default Footer;
